import firebaseModules from "./Firebase";

const storage = firebaseModules.storage;

export const uploadFile = async (folder, fileName, fileDetails) => {
  const uploadName = `${folder}/${fileName}.${fileDetails.type}`;
  const ref = storage.ref().child(uploadName);
  let blob = await fetch(fileDetails.src).then((r) => r.blob());

  const snapshot = await ref.put(blob);
  return await snapshot.ref.getDownloadURL();
};
